export class BackgroundStatusUpdatesModule {

    public static isScreenOn(): boolean {
        return true
    }

}
